import React, { useId } from 'react'
import PropTypes from 'prop-types'

const AvatarCircleIcon = React.forwardRef(function AvatarCircleIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M24 12C24 5.38 18.62 0 12 0C5.38 0 0 5.38 0 12C0 15.31 1.35 18.32 3.53 20.49C3.55 20.51 3.57 20.52 3.58 20.54C5.75 22.68 8.72 24 12 24C15.24 24 18.17 22.71 20.33 20.62C20.44 20.55 20.55 20.45 20.62 20.33V20.32C22.71 18.16 24 15.23 24 12ZM12 2C17.51 2 22 6.49 22 12C22 14.5 21.07 16.78 19.55 18.53C19.2 18.37 18.8 18.21 18.31 18.05C16.1 17.31 16 16.03 16 16C16 15.84 15.95 15.7 15.89 15.56C17.18 14.46 18 12.83 18 11V9C18 5.69 15.31 3 12 3C8.69 3 6 5.69 6 9V11C6 12.83 6.82 14.46 8.11 15.56C8.05 15.69 8.01 15.83 8 15.97C8 16.02 7.9 17.31 5.68 18.05C5.19 18.21 4.79 18.37 4.44 18.53C2.93 16.78 2 14.5 2 12C2 6.49 6.49 2 12 2ZM8 11V9C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9V11C16 13.21 14.21 15 12 15C9.79 15 8 13.21 8 11ZM6.07 20.03C6.15 20 6.23 19.97 6.31 19.94C8.92 19.07 9.68 17.48 9.9 16.61C10.56 16.86 11.26 17 12 17C12.74 17 13.44 16.86 14.09 16.62C14.31 17.49 15.07 19.08 17.68 19.95C17.77 19.98 17.84 20.01 17.92 20.04C16.27 21.26 14.22 22 12 22C9.78 22 7.73 21.26 6.07 20.03Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

AvatarCircleIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

AvatarCircleIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default AvatarCircleIcon
